import React, { useContext, useMemo } from "react";
import { Tooltip } from "antd";
import { AppContext } from "../../../context/AppContext";

const FilterSummary = ({
  className = "navbar-filter-summary__content",
}) => {
  const { selectedReportDetails, selectedReportLoading, selectedReportStatus } = useContext(AppContext);

  // Single source of truth: selectedReportDetails
  const projectCode = selectedReportDetails?.project?.code || "-";
  const regionName = selectedReportDetails?.region?.name || "-";
  const councilName = selectedReportDetails?.council?.name || "-";
  const reportLabel = useMemo(() => {
    const n = selectedReportDetails?.report_number;
    const s = selectedReportDetails?.start ? String(selectedReportDetails.start).slice(0, 10) : null;
    const e = selectedReportDetails?.end ? String(selectedReportDetails.end).slice(0, 10) : null;
    return n && s && e ? `RN #${n}: ${s} - ${e}` : "-";
  }, [selectedReportDetails]);

  const isLoading = selectedReportLoading;
  const hasError = selectedReportStatus === 'error';

  return (
    <div className={className}>
      <Tooltip title={hasError ? 'Report failed to load. Click to reselect.' : `Project(${isLoading ? "Loading…" : projectCode})`}>
        <span className="navbar-filter-summary__part">{hasError ? 'Select Report' : `Project(${isLoading ? "Loading…" : projectCode})`}</span>
      </Tooltip>
      <span className="navbar-filter-summary__separator">&gt;</span>
      <Tooltip title={`Region(${isLoading ? "Loading…" : regionName})`}>
        <span className="navbar-filter-summary__part">{`Region(${isLoading ? "Loading…" : regionName})`}</span>
      </Tooltip>
      <span className="navbar-filter-summary__separator">&gt;</span>
      <Tooltip title={`LGA(${isLoading ? "Loading…" : councilName})`}>
        <span className="navbar-filter-summary__part">{`LGA(${isLoading ? "Loading…" : councilName})`}</span>
      </Tooltip>
      <span className="navbar-filter-summary__separator">&gt;</span>
      <Tooltip title={`CSC Report(${isLoading ? "Loading…" : reportLabel})`}>
        <span className="navbar-filter-summary__part">{`CSC Report(${isLoading ? "Loading…" : reportLabel})`}</span>
      </Tooltip>
      <span className="navbar-filter-summary__caret" aria-hidden>▾</span>
    </div>
  );
};

export default FilterSummary;


